import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import TabHeader from "root/components/TabHeader";
import t from "common/i18n";
import useCurrentPage from "../../hooks/useCurrentPage";
import { MEDIA_TYPES } from "../../data/consts";
import { useSearchParams, useSelectedAsset, useAccountInfo } from "../../getty-selectors";
import { useAssets } from "../../selectors";
import { getInternalPath } from "../../utils";
import { TabHeaderButtons } from "../../../common/components/TabHeaderButtons";

const MEDIA_TYPES_VALUES = Object.values(MEDIA_TYPES);

export default ({ handleLogout, handleSearch, handleClearSearchTerm, handleTogglePanel, isFiltersPanelOpen, areFiltersSet, source, routes }) => {
	const history = useHistory();
	const [searchPhraseLocal, setSearchPhraseLocal] = useState("");
	const [mediaTypeLocal, setMediaTypeLocal] = useState(MEDIA_TYPES.IMAGES);
	const { searchPhrase, mediaType } = useSearchParams(source);
	const { selectedAsset } = useSelectedAsset(source);
	const { isPurchasePage } = useCurrentPage(source, routes);
	const { items } = useAssets(source);
	const { userName } = useAccountInfo(source);

	useEffect(() => {
		setSearchPhraseLocal(searchPhrase);
		setMediaTypeLocal(mediaType);
	}, [searchPhrase, mediaType]);

	const clearSearchTerm = useCallback(() => {
		handleClearSearchTerm({ searchPhrase: searchPhraseLocal, mediaType: MEDIA_TYPES.IMAGES });
	}, [handleClearSearchTerm, searchPhraseLocal]);

	const onSearch = useCallback(() => {
		handleSearch({ searchPhrase: searchPhraseLocal });
	}, [handleSearch, searchPhraseLocal]);

	const onMediaTypeChange = useCallback((mediaType) => {
		setMediaTypeLocal(mediaType.value);
		handleSearch({ mediaType: mediaType.value });
	}, [setMediaTypeLocal, handleSearch]);

	const handlePurchaseBack = useCallback(() => {
		if (items.length) {
			history.push(getInternalPath(source, routes.SEARCH));
		}
		else {
			history.push(getInternalPath(source, routes.HOME));
		}
	}, [history, items.length, routes.HOME, routes.SEARCH, source]);

	const mediaTypes = MEDIA_TYPES_VALUES.map((value: any): any => ({
		label: t(`${source}.media_types.${value}`),
		value,
	}));

	const mediaTypeLabelLocal = (mediaTypes.find((type) => type.value === mediaTypeLocal) ?? {}).label;

  return (
	<TabHeader
		source={source}
		searchTerm={searchPhraseLocal}
		expandSearch
		hideBackButton
		userName={userName}
		onLogout={handleLogout}
		searchClickHandler={onSearch}
		searchTermHandler={setSearchPhraseLocal}
		searchOptions={mediaTypes}
		selectedSearchOption={mediaTypeLabelLocal}
		searchOptionHandler={onMediaTypeChange}
		clearBtnTip={t(`${source}.search.reset`)}
		showClearButton={!!searchPhraseLocal}
		onClearClickHandler={clearSearchTerm}
		onEscClickHandler={clearSearchTerm}
		searchInputPlaceholder={t(`${source}.search.placeholder`)}
		titleCenter={isPurchasePage && selectedAsset?.title}
		showBackButton={isPurchasePage}
		showSearch={!isPurchasePage}
		onBackNavigation={handlePurchaseBack}
	>
		  {!isPurchasePage &&
			  <TabHeaderButtons
				  id={source}
				  routes={routes}
				  searchTerm={searchPhraseLocal}
				  clearSearchTerm={() => clearSearchTerm()}
				  isFiltersPanelOpen={isFiltersPanelOpen}
				  showIndicator={areFiltersSet && !isFiltersPanelOpen}
				  toggleFilterPanel={handleTogglePanel}
			  />
		  }
	</TabHeader>
  );
};
